import { useRouter } from 'next/router'

import useActiveUserInfo from '@/hooks/useActiveUserInfo'
import BaseButton from '@/ui/Button/v2'

import SignInButton from '../SignInButton'

import NoPortalMembershipNotice from './NoPortalMembershipNotice'
import { goBackToDashboardButton, sigInAndPayButton } from './styles'

const InvalidInvoiceRedirectButtons = () => {
  const { push } = useRouter()
  const {
    user,
    loading: loadingUser,
    hasNoPortalMembership
  } = useActiveUserInfo()
  const isLoggedInAsCustomer = user && user.role !== 'guest' && !loadingUser
  const redirectUrl = '/dashboard'

  if (hasNoPortalMembership) return <NoPortalMembershipNotice />

  return (
    <>
      {!isLoggedInAsCustomer && (
        <SignInButton
          text='Sign in to see more'
          styles={{ ...sigInAndPayButton }}
          redirectUrl={redirectUrl}
        />
      )}

      {isLoggedInAsCustomer && (
        <BaseButton
          styles={{
            ...goBackToDashboardButton
          }}
          onClick={() => push(redirectUrl)}
        >
          Go back to dashboard
        </BaseButton>
      )}
    </>
  )
}

export default InvalidInvoiceRedirectButtons
